import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SubmissionDetails from '../../../SubmissionDetails';
import GruserZoneLocal from '../../GruserZone/Local';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import ExtendedDetails from './ExtendedDetails';
import s from './Default.scss';
export const DefaultDetails = ({ deviation, className, contentClassName })=>{
    const isMobile = useContext(MobileContext);
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, contentClassName)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title-block']
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation,
        showTitle: true
    })), isExtendedLoaded && /*#__PURE__*/ React.createElement(ExtendedDetails, {
        deviation: deviation
    }), !isMobile && /*#__PURE__*/ React.createElement(GruserZoneLocal, {
        deviation: deviation
    }));
};
DefaultDetails.displayName = 'DefaultDetails';
export default DefaultDetails;
